export default __webpack_public_path__ + "static/Entenda0039-63f63f9658952bebb571d88db5d244df.jpg";